import { render, staticRenderFns } from "./Self.vue?vue&type=template&id=4ec42030&scoped=true&"
import script from "./Self.vue?vue&type=script&lang=js&"
export * from "./Self.vue?vue&type=script&lang=js&"
import style0 from "./Self.vue?vue&type=style&index=0&id=4ec42030&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec42030",
  null
  
)

export default component.exports